"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new Error('The installed version of React does not support Hooks. ' +
    'Upgrade to React v16.8.0 or later.');



//////////////////
// WEBPACK FOOTER
// ./node_modules/reactn/build/utils/react-hooks-error.js
// module id = 199
// module chunks = 0